import { BaseElementToSimpleSapElementMapper } from "../baseElementToSimpleSapElementMapper";
import Element from '@/models/element';
import { ISimpleSapElement, SimpleSapElement } from '@/models/api/models/simpleSapElement';
import { DeskLegsToSimpleSapElementMapper } from '../desk/deskLegsToSimpleSapElementMapper';

export class TableLegsToSimpleSapElementMapper
    extends DeskLegsToSimpleSapElementMapper {

    public map(element: Element): ISimpleSapElement[] {
        const code = this.toLegsType(element);
        const type = this.formatType(code, 7, 3);
        return [SimpleSapElement.LEG(type, '')];
    }
}
